import { css } from "@stubhub/broadway-foundation/css";

// Full-height hero container — inherits StyledBigImmersiveHeader base (flex column, relative position)
// Phone: 360px (immersive, nav lives inside hero). Tablet+: 400px page-level strip.
export const venueHeroHeaderStyle = css({
  display: "flex",
  flexDirection: "column",
  position: "relative",
  minHeight: "[200px]",
  // Extra bottom padding creates dark gradient space below the venue text so the
  // body card's rounded top corners overlap cleanly against the hero background.
  height: "[288px]",
  paddingBlockEnd: "[24px]",
  tablet: {
    minHeight: "[280px]",
    height: "[400px]",
    paddingBlockEnd: "[0]",
  },
});

// Full-hero gradient overlay for text readability on all viewports
export const venueFullGradientStyle = css({
  position: "absolute",
  insetBlock: "[0]",
  insetInline: "[0]",
  backgroundImage: "[linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.69) 100%)]",
  pointerEvents: "none",
});
